export default "__VITE_ASSET__CVjjd79S__"